import IRoute from 'interfaces/route'
import LoginPage from 'pages/Login'
import SelectAssessment from 'pages/SelectAssessment'
import Assessment from 'pages/Assessment'
import AssessmentV2 from 'pages/AssessmentV2/Assessment'
import ClassroomDashboard from 'pages/ClassroomDashboard/ClassroomDashboard'

const routes: IRoute[] = [
  {
    path: '/',
    name: 'Login',
    component: LoginPage
  },
  {
    path: '/select-assessment',
    name: 'Select Assessment',
    component: SelectAssessment
  },
  {
    path: '/:assessmentType/:id',
    name: 'Assessment',
    component: localStorage.assessment === 'V1' ? Assessment : AssessmentV2
  },
  {
    path: '/classroom',
    name: 'Classroom Dashboard',
    component: ClassroomDashboard
  }
]

export default routes
